const provinces = [
  {
    id: 1,
    name: 'آذربایجان شرقی',
    slug: 'آذربایجان-شرقی',
    latitude: 37.9035733,
    longitude: 46.2682109
  },
  {
    id: 2,
    name: 'آذربایجان غربی',
    slug: 'آذربایجان-غربی',
    latitude: 37.4550062,
    longitude: 45
  },
  {
    id: 3,
    name: 'اردبیل',
    slug: 'اردبیل',
    latitude: 38.4853276,
    longitude: 47.8911209
  },
  {
    id: 4,
    name: 'اصفهان',
    slug: 'اصفهان',
    latitude: 32.6546275,
    longitude: 51.6679826
  },
  {
    id: 5,
    name: 'البرز',
    slug: 'البرز',
    latitude: 35.9960467,
    longitude: 50.9289246
  },
  {
    id: 6,
    name: 'ایلام',
    slug: 'ایلام',
    latitude: 33.2957618,
    longitude: 46.670534
  },
  {
    id: 7,
    name: 'بوشهر',
    slug: 'بوشهر',
    latitude: 28.9233837,
    longitude: 50.820314
  },
  {
    id: 8,
    name: 'تهران',
    slug: 'تهران',
    latitude: 35.696111,
    longitude: 51.423056
  },
  {
    id: 9,
    name: 'چهارمحال و بختیاری',
    slug: 'چهارمحال-و-بختیاری',
    latitude: 31.9614348,
    longitude: 50.8456323
  },
  {
    id: 10,
    name: 'خراسان جنوبی',
    slug: 'خراسان-جنوبی',
    latitude: 32.5175643,
    longitude: 59.1041758
  },
  {
    id: 11,
    name: 'خراسان رضوی',
    slug: 'خراسان-رضوی',
    latitude: 35.1020253,
    longitude: 59.1041758
  },
  {
    id: 12,
    name: 'خراسان شمالی',
    slug: 'خراسان-شمالی',
    latitude: 37.4710353,
    longitude: 57.1013188
  },
  {
    id: 13,
    name: 'خوزستان',
    slug: 'خوزستان',
    latitude: 31.4360149,
    longitude: 49.041312
  },
  {
    id: 14,
    name: 'زنجان',
    slug: 'زنجان',
    latitude: 36.5018185,
    longitude: 48.3988186
  },
  {
    id: 15,
    name: 'سمنان',
    slug: 'سمنان',
    latitude: 35.2255585,
    longitude: 54.4342138
  },
  {
    id: 16,
    name: 'سیستان و بلوچستان',
    slug: 'سیستان-و-بلوچستان',
    latitude: 27.5299906,
    longitude: 60.5820676
  },
  {
    id: 17,
    name: 'فارس',
    slug: 'فارس',
    latitude: 29.1043813,
    longitude: 53.045893
  },
  {
    id: 18,
    name: 'قزوین',
    slug: 'قزوین',
    latitude: 36.0881317,
    longitude: 49.8547266
  },
  {
    id: 19,
    name: 'قم',
    slug: 'قم',
    latitude: 34.6399443,
    longitude: 50.8759419
  },
  {
    id: 20,
    name: 'كردستان',
    slug: 'كردستان',
    latitude: 35.9553579,
    longitude: 47.1362125
  },
  {
    id: 21,
    name: 'كرمان',
    slug: 'كرمان',
    latitude: 30.2839379,
    longitude: 57.0833628
  },
  {
    id: 22,
    name: 'كرمانشاه',
    slug: 'كرمانشاه',
    latitude: 34.314167,
    longitude: 47.065
  },
  {
    id: 23,
    name: 'کهگیلویه و بویراحمد',
    slug: 'کهگیلویه-و-بویراحمد',
    latitude: 30.6509479,
    longitude: 51.60525
  },
  {
    id: 24,
    name: 'گلستان',
    slug: 'گلستان',
    latitude: 37.2898123,
    longitude: 55.1375834
  },
  {
    id: 25,
    name: 'گیلان',
    slug: 'گیلان',
    latitude: 37.1171617,
    longitude: 49.5279996
  },
  {
    id: 26,
    name: 'لرستان',
    slug: 'لرستان',
    latitude: 33.5818394,
    longitude: 48.3988186
  },
  {
    id: 27,
    name: 'مازندران',
    slug: 'مازندران',
    latitude: 36.2262393,
    longitude: 52.5318604
  },
  {
    id: 28,
    name: 'مركزی',
    slug: 'مركزی',
    latitude: 33.5093294,
    longitude: -92.396119
  },
  {
    id: 29,
    name: 'هرمزگان',
    slug: 'هرمزگان',
    latitude: 27.138723,
    longitude: 55.1375834
  },
  {
    id: 30,
    name: 'همدان',
    slug: 'همدان',
    latitude: 34.7607999,
    longitude: 48.3988186
  },
  {
    id: 31,
    name: 'یزد',
    slug: 'یزد',
    latitude: 32.1006387,
    longitude: 54.4342138
  }
];

export { provinces };
